const edgeYears = 150;
const now = new Date();

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function calcAge(dateString) {
  const birthday = new Date(dateString);

  if (!isValidDate(birthday)) {
    return 0;
  }

  const age = now.getFullYear() - birthday.getFullYear();

  const hasBirthdayPassedThisYear =
    now >= new Date(now.getFullYear(), birthday.getMonth(), birthday.getDate());

  return hasBirthdayPassedThisYear ? age : age - 1;
}

export const validateAge = (minimumAge, year, month = '1', day = '1') => {
  if (!year || year.length < 4) {
    return false;
  }

  const fullAge = calcAge(`${month}/${day}/${year}`);

  return fullAge >= minimumAge && Math.abs(fullAge) < edgeYears;
};
